<template>
  <a-card :bordered="false" :class="'cust-erp-sub-tab'">
    <!-- 操作按钮区域 -->
    <div class="table-operator" v-if="mainId">
      <a-button @click="handleAdd" icon="plus" type="primary">新增</a-button>
      <a-button @click="handleExportXls('三维自定义工艺测点')" icon="download" type="primary">导出</a-button>
      <a-upload
        :action="importExcelUrl"
        :headers="tokenHeader"
        :multiple="false"
        :showUploadList="false"
        @change="handleImportExcel"
        name="file"
      >
        <a-button icon="import" type="primary">导入</a-button>
      </a-upload>
      <!-- 高级查询区域 -->
      <j-super-query :fieldList="superFieldList" @handleSuperQuery="handleSuperQuery" ref="superQueryModal"></j-super-query>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item @click="batchDel" key="1">
            <a-icon type="delete" />删除
          </a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px">
          批量操作
          <a-icon type="down" />
        </a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
        <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a @click="onClearSelected" style="margin-left: 24px">清空</a>
      </div>

      <a-table
        :columns="columns"
        :dataSource="dataSource"
        :loading="loading"
        :pagination="ipagination"
        :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :scroll="{ x: true }"
        @change="handleTableChange"
        bordered
        ref="table"
        rowKey="id"
        size="middle"
      >
        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span style="font-size: 12px;font-style: italic;" v-if="!text">无图片</span>
          <img
            :src="getImgView(text)"
            alt
            height="25px"
            style="max-width:80px;font-size: 12px;font-style: italic;"
            v-else
          />
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span style="font-size: 12px;font-style: italic;" v-if="!text">无文件</span>
          <a-button :ghost="true" @click="downloadFile(text)" icon="download" size="small" type="primary" v-else>下载</a-button>
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical" />
          <a-popconfirm @confirm="() => handleDelete(record.id)" title="确定删除吗?">
            <a>删除</a>
          </a-popconfirm>
        </span>
      </a-table>
    </div>

    <customSzwtProcessPoints-modal :mainId="mainId" @ok="modalFormOk" ref="modalForm"></customSzwtProcessPoints-modal>
  </a-card>
</template>

<script>
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import CustomSzwtProcessPointsModal from './modules/CustomSzwtProcessPointsModal'

  export default {
    name: 'CustomSzwtProcessPointsList',
    mixins: [JeecgListMixin],
    components: { CustomSzwtProcessPointsModal },
    props: {
      mainId: {
        type: String,
        default: '',
        required: false
      }
    },
    watch: {
      mainId: {
        immediate: true,
        handler (val) {
          if (!this.mainId) {
            this.clearList()
          } else {
            this.queryParam['devProcessId'] = val
            this.loadData(1)
          }
        }
      }
    },
    data () {
      return {
        description: '三维自定义供水流域配置管理页面',
        disableMixinCreated: true,
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key: 'rowIndex',
            width: 60,
            align: 'center',
            customRender: function (t, r, index) {
              return parseInt(index) + 1
            }
          },
          {
            title: '点号',
            align: 'center',
            dataIndex: 'pointCode',
            sorter: true
          },
          {
            title: '点名称',
            align: 'center',
            dataIndex: 'pointName',
            sorter: true
          },
          {
            title: '排序',
            align: 'center',
            dataIndex: 'orderNum',
            sorter: true
          },
          {
            title: '操作',
            dataIndex: 'action',
            align: 'center',
            fixed: 'right',
            width: 147,
            scopedSlots: { customRender: 'action' }
          }
        ],
        url: {
          list: '/custom/customSzwtProcess/listCustomSzwtProcessPointsByMainId',
          delete: '/custom/customSzwtProcess/deleteCustomSzwtProcessPoints',
          deleteBatch: '/custom/customSzwtProcess/deleteBatchCustomSzwtProcessPoints',
          exportXlsUrl: '/custom/customSzwtProcess/exportCustomSzwtProcessPoints',
          importUrl: '/custom/customSzwtProcess/importCustomSzwtProcessPoints'
        },
        dictOptions: {},
        superFieldList: []
      }
    },
    created () {
      this.getSuperFieldList()
    },
    computed: {
      importExcelUrl () {
        return `${window._CONFIG['domianURL']}/${this.url.importUrl}/${this.mainId}`
      }
    },
    methods: {
      clearList () {
        this.dataSource = []
        this.selectedRowKeys = []
        this.ipagination.current = 1
      },
      getSuperFieldList () {
        let fieldList = []
        fieldList.push({ type: 'string', value: 'processName', text: '供水流域名称', dictCode: '' })
        fieldList.push({ type: 'BigDecimal', value: 'offsetz', text: '高度偏移', dictCode: '' })
        fieldList.push({ type: 'string', value: 'pid', text: '父节点', dictCode: '' })
        this.superFieldList = fieldList
      }
    }
  }
</script>
<style scoped>

  @import '~@assets/less/common.less';

</style>
